import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, NgIf } from '@angular/common';
import { NgFor } from '@angular/common';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatSelectModule } from '@angular/material/select';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { DOCUMENT, NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { FuseFindByKeyPipe } from '@fuse/pipes/find-by-key/find-by-key.pipe';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { group } from '@angular/animations';


@Component({
    templateUrl: './backend.type.html',
    styleUrls: ['./backend.type.scss'],
  standalone:true,
  imports:[
    NgFor,
    MatButtonModule,
    ReactiveFormsModule,
    FormlyMaterialModule,
    MatOptionModule,
    FormlyModule,
    MatSelectModule,
    MatInputModule,
    MatSidenavModule,
    MatIconModule,
    MatProgressBarModule,
    MatStepperModule]
})
export class FormlyFieldBackend extends FieldType  implements OnInit {


    private _unsubscribeAll: Subject<any> = new Subject<any>();


    pagamentiTotali:number = 0;

    showPagamenti: boolean = false;

    /*
    disableFields(fields:FormlyFieldConfig): void {
        fields.fieldGroup.forEach((f)=>{
            if (f.key){
                if (f.key!='riepilogo_ok'){
                    f.props.disabled = true;
                }
            }
            else if (f.fieldGroup) {
                this.disableFields(f)
            }
        })
    }*/

    ngOnInit(): void {

        //this.pagamentiTotali = this.model.pagamenti.length;

        console.log(this.field.fieldGroup)

        //this.disableFields(this.field);
        //this.form.disable()
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }


    isValid(field: FormlyFieldConfig): boolean {

        console.log(this.form.status)

        if (field.key) {
            return field.formControl.valid;
        }
        return field.fieldGroup ? field.fieldGroup.every((f) => f.hide || this.isValid(f)) : true;
    }

    check(field_name:string): boolean{
        return true
    }


}
